<template>
  <div class="nettdoc-symptom-details">
    <h2 class="nettdoc-header nettdoc-symptom-details__header">{{$t('Give more information about your condition.')}}</h2>
    <component
      v-for="(value, symptom) in store.additionalConditions"
      :is="symptom === 'pregnancy' && value === 'yes' ? symptom : ''"
      :key="symptom"
      :store="store"
    />
    <component
      v-for="(value, symptom) in store.symptoms"
      :is="value && symptom !== 'childrensDisease' ? symptom : ''"
      :key="symptom"
      :store="store"
    />

    <Button 
      text="Submit"
      :active="store.symptomDetailsComplete"
      v-on:action="submit"
    />
  </div>
</template>

<script>
import { observer } from "mobx-vue";
import store from "../store/store";
import Button from "../components/Button";

import BreathingProblems from "../components/SymptomDetails/BreathingProblems";
import Pain from "../components/SymptomDetails/Pain";
import ProblemsOfDigestion from "../components/SymptomDetails/ProblemsOfDigestion";
import RaisedBodyTemperature from "../components/SymptomDetails/RaisedBodyTemperature";
import Dizziness from "../components/SymptomDetails/Dizziness";
import Pregnancy from "../components/SymptomDetails/Pregnancy";
import WeaknessOrExhaustion from "../components/SymptomDetails/WeaknessOrExhaustion";
import ParalysisDeafnessPrickle from "../components/SymptomDetails/ParalysisDeafnessPrickle";
import SensoryPerception from "../components/SymptomDetails/SensoryPerception";
import Swelling from "../components/SymptomDetails/Swelling";
import GynecologicalIssues from "../components/SymptomDetails/GynecologicalIssues";
import RashItchRedness from "../components/SymptomDetails/RashItchRedness";
export default observer({
  name: "SymptomDetails",
  data() {
    return {
      store: store
    };
  },
  components: {
    Button,
    BreathingProblems,
    Pain,
    Pregnancy,
    WeaknessOrExhaustion,
    ParalysisDeafnessPrickle,
    SensoryPerception,
    ProblemsOfDigestion,
    RaisedBodyTemperature,
    Dizziness,
    Swelling,
    RashItchRedness,
    GynecologicalIssues
  },
  created() {
    this.store.persistSymptoms()
    this.store.persistAdditionalConditions()
    this.store.persistAdditionalConditionDetails()
    this.store.persistSymptomDetails()
    this.store.persistParalysisDeafnessPrickleDetails()
    this.store.persistSensoryPerceptionDetails()
  },
  methods: {
    submit: function() {
      if (this.store.symptomDetailsComplete) {
        this.$router.push(`/${this.$i18n.locale}/nettdoctor/patientinformation`)
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.nettdoc-symptom-details {
  position: absolute;
  width: 100%;
  background-color: #ffffff;
  &__header {
    margin: 10px 0;
  }
}
</style>